module.exports = __webpack_public_path__ + "static/media/icon-spa.e7609755.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/amenities/icon-spa.svg
// module id = 706
// module chunks = 6